module.exports = __webpack_public_path__ + "static/media/reply_all.7a31f6fd.svg";